module.exports = __webpack_public_path__ + "static/img/til114.d5902ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til114.png
// module id = 2SVi
// module chunks = 1